// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__3K-xX","checkboxCol":"Table_checkboxCol__2mvEU","emailCol":"Table_emailCol__3WZhv","actionCol":"Table_actionCol__3dpz0"};